import React from 'react'
import './searchBox.scss'

interface SearchBoxProps {
    value: string;
    startSearch(query: string): void
}

interface SearchBoxState {
    input: string;
}

class SearchBox extends React.Component<SearchBoxProps, SearchBoxState> {
    constructor(props: SearchBoxProps) {
        super(props)

        this.state = { input: props.value }
    }

    onValueChanged(newValue: string) {
        this.setState({ input: newValue });
    }

    render() {
        return (
            <form className="SearchBox" onSubmit={e => { e.preventDefault(); this.props.startSearch(this.state.input); }}>
                <input autoFocus type="text" placeholder="Type something..." onChange={e => this.onValueChanged(e.target.value)} value={this.state.input} />
                <button type="submit">Search</button>
            </form>
        );
    }
}

export default SearchBox;